import { getVariantItemImageUrl } from './get-product-image-url.js';

/**
 * @deprecated
 */ const consolidateParentFacets = (variants)=>{
    const parentFacetsMap = new Map();
    variants.forEach((variant1)=>{
        const { facets , sku , slug , media , displayName , isPublished  } = variant1;
        if (!isPublished) return;
        if (!facets.color && !facets.size && !!facets.other) {
            /* 
      for now 'other" facets are mutually exclusive from size & color. Meaning that 'other' facets don't support multivariancy.
      so the facet tree is either:
          color, with size as a child facet
          other, without any child facets
      */ const parentFacetItem = parentFacetsMap.get(facets.other) || {
                facetTerm: facets.other,
                type: 'other',
                sku,
                slug,
                name: displayName,
                imageUrl: getVariantItemImageUrl(media),
                childFacets: [],
                skuCollection: [],
                showFacetName: false
            };
            parentFacetItem.skuCollection.push(sku);
            parentFacetsMap.set(facets.other, parentFacetItem);
        } else if (facets.color) {
            /**
       * If a product contains multiple variants with the same color, they should be shown as separate variants.
       * If the product contains size information, these variants show up under the same color as different size options (e.g. 2x "MEDIUM" option).
       * If a product does not contain size information, the variants should not be grouped by color,
       * because in that case, the individual color variants can separately be considered facets.
       */ const productContainsSizeInformation = variants.some((variant)=>variant.facets.size
            );
            const facetMapKey = productContainsSizeInformation ? facets.color // same key for all variants with the same color - size facet will handle rendering variants individually
             : `${facets.color}-${variant1.sku}` // unique key for each variant - color facet will handle rendering variants individually
            ;
            const parentFacetItem = parentFacetsMap.get(facetMapKey) || {
                facetTerm: facets.color,
                type: 'color',
                slug,
                name: displayName,
                imageUrl: getVariantItemImageUrl(media),
                childFacets: [],
                sku,
                skuCollection: [],
                showFacetName: true
            };
            // Add facets.size if available
            if (!!facets.size) {
                const newChildFacet = {
                    facetTerm: facets.size,
                    type: 'size',
                    sku,
                    slug,
                    name: displayName,
                    showFacetName: false
                };
                parentFacetItem.childFacets.push(newChildFacet);
            }
            parentFacetItem.skuCollection.push(sku);
            parentFacetsMap.set(facetMapKey, parentFacetItem);
        }
    });
    const facetsMap = Object.fromEntries(parentFacetsMap);
    const parentFacets = Object.values(facetsMap);
    return parentFacets;
};

export { consolidateParentFacets };
//# sourceMappingURL=consolidate-parent-facets.js.map
